import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HTTP_INTERCEPTORS} from '@angular/common/http';
import {NavigationEnd, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';

import {authorizationPrefix, localStorageToken} from '../_common/constants';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    previousUrl: string;

    constructor(private readonly router: Router) {
        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .subscribe((event: any) => {
                // Only store the routed url if it doesn't already contain a "returnUrl"
                // This will ensure that we don't run into an issue with cascading returnUrl parameters
                // in the url.
                if (
                    event.urlAfterRedirects.indexOf("returnUrl") === -1 &&
                    event.urlAfterRedirects.indexOf("login") === -1 &&
                    event.urlAfterRedirects.indexOf("logout") === -1
                ) {
                    this.previousUrl = event.urlAfterRedirects;
                }
            });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add authorization header with JWT token if available.
        const token = localStorage.getItem(localStorageToken);
        if (token) {
            request = request.clone({
                setHeaders: {Authorization: `${authorizationPrefix}${token}`}
            });
        }

        return next.handle(request)
            .do((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        // Do nothing, for now.
                    }
                }, (error: any) => {
                    if (error instanceof HttpErrorResponse) {
                        if (error.status === 401) {
                            if (this.previousUrl) {
                                this.router.navigate(['/account/login'], { queryParams: { returnUrl: this.previousUrl } });
                            } else {
                                this.router.navigate(['/account/login']);
                            }
                        }
                    }
                }
            );
    }
}

export const JwtInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: JwtInterceptor,
    multi: true,
};



// WEBPACK FOOTER //
// ./src/app/_interceptors/jwt.interceptor.ts